/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAppointmentTypeRequestDto
 */
export interface CreateAppointmentTypeRequestDto {
    /**
     * Appointment type name
     * @type {string}
     * @memberof CreateAppointmentTypeRequestDto
     */
    name: string;
    /**
     * Appointment type color code
     * @type {string}
     * @memberof CreateAppointmentTypeRequestDto
     */
    colorCode: string;
    /**
     * Appointment type duration in minutes
     * @type {number}
     * @memberof CreateAppointmentTypeRequestDto
     */
    duration: number;
}

/**
 * Check if a given object implements the CreateAppointmentTypeRequestDto interface.
 */
export function instanceOfCreateAppointmentTypeRequestDto(value: object): value is CreateAppointmentTypeRequestDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('colorCode' in value) || value['colorCode'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    return true;
}

export function CreateAppointmentTypeRequestDtoFromJSON(json: any): CreateAppointmentTypeRequestDto {
    return CreateAppointmentTypeRequestDtoFromJSONTyped(json, false);
}

export function CreateAppointmentTypeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAppointmentTypeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'colorCode': json['colorCode'],
        'duration': json['duration'],
    };
}

export function CreateAppointmentTypeRequestDtoToJSON(json: any): CreateAppointmentTypeRequestDto {
    return CreateAppointmentTypeRequestDtoToJSONTyped(json, false);
}

export function CreateAppointmentTypeRequestDtoToJSONTyped(value?: CreateAppointmentTypeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'colorCode': value['colorCode'],
        'duration': value['duration'],
    };
}

